export interface SectionIds {
  about: string;
  services: string;
  whyChooseUs: string;
  booking: string;
  faqBlog: string;
  contact: string;
}

export const sectionIds: SectionIds = {
  about: "a-propos",
  services: "services",
  whyChooseUs: "pourquoi-nous-choisir",
  booking: "rendez-vous",
  faqBlog: "faq-blog",
  contact: "contact",
};
